export default {
  //中文
  welcome: "欢迎访问南京大学小鼠表型数据库",
  search: "搜索",
  previousArticle: "上一篇",
  nextArticle: "下一篇",
  home: "首页",
  phenotypeCompare: "表型对比",
  compare: "开始对比",
  total: "已选",
  loginOrRegister: "登录/注册",
  personalInfo: "个人信息",
  logout: "退出登录",
  selectTwoPhenotype: "请至少选择2个品系进行对比",
  maxCompare: "最多只能添加5个品系进行对比",
  registerNJU: "注册NJU小鼠表型数据库",
  registerName: "请输入姓名，长度限制2-20个字符",
  registerPhone: "输入手机号码",
  registerGroup: "请输入课题组名称",
  registerEmail: "请输入邮箱",
  registerCaptcha: "请输入图形验证码",
  registerCaptchaCode: "请输入图形验证码",
  sendEmail: "发送",
  password: "密码：8-16位，大小写字母+数字",
  password1: '账号密码',
  registerEmailCode: "请输入邮箱验证码",
  rePassword: "请再次输入密码",
  registerBtn: "立即注册",
  loginTips: "已经注册？",
  loginBtn: "去登录",
  welcomeLogin: "欢迎登录",
  loginTips2: "登录后即可查看完整小鼠表型数据",
  loginSuccess: "登录成功",
  forgetPassword: "忘记密码？",
  setPassword: "请设置密码",
  confirmPassword: "请确认密码",
  confirmPasswordError: "两次密码输入不一致",
  passwordError: "8-16位字符，包含大小写字母和数字",
  emailError: "邮箱格式不正确",
  forgetEmail: "请输入邮箱",
  forgetCaptcha: "请输入图形验证码",
  sendSuccess: "发送成功",
  resetSuccess: "重置成功",
  loginEmail: "请输入邮箱",
  loginPassword: "请输入密码",
  loginCaptcha: "请输入验证码",
  noAccount: "没有账号？",
  searchGene: "请输入基因symbol或者NCBI编号",
  iconIntroduce: "图标说明",
  embryoStemCell: "有胚胎",
  noEmbryoStemCell: "无胚胎",
  mouse: "有活体小鼠",
  noMouse: "无活体小鼠",
  sperm: "有精子",
  noSperm: "无精子",
  compared: "已添加",
  expand: "展开",
  collapse: "收起",
  year: "年",
  month: "月",
  day: "日",
  pleaseEnterPasswordAgain: "请检查输入",
  name: "姓名",
  email: "邮箱",
  phone: "手机号",
  company: "单位",
  group: "课题组",
  applicationResult: "申请结果",
  applicationTime: "申请时间",
  reset: "重置",
  newApplication: "新建申请",
  pleaseFillInTheFollowingInformation:
    "如需查看隐藏品系数据信息，请填写以下信息",
  applicationInfo: "申请信息",
  pleaseEnterTheEmailAccount: "请输入邮箱账号",
  pleaseEnterTheRemark: "请输入备注",
  emailAccount: "邮箱账号",
  remark: "备注",
  NJUMPDBNumber: "NJUMPDB编号",
  addNJUMPDBNumber: "新增NJUMPDB编号",
  cancel: "取消",
  confirm: "确认",
  approved: "已审批",
  unapproved: "未审批",
  phenotypeNumberRepeat: "品系编号重复",
  submitSuccess: "提交成功",
  atLeastOnePhenotypeNumber: "至少保留一个品系编号",
  maxAddFivePhenotypeNumber: "最多添加5个品系编号",
  startTime: "开始时间",
  endTime: "结束时间",
  youHaveAppliedTo: "您已向",
  owner: "所有人",
  applyToSeeTheFollowingPhenotypeNumberPermission:
    "申请查看以下南大ID品系数据权限",
  agree: "已同意",
  disagree: "不同意",
  productLineApplication: "品系申请",
  passwordConfig: "密码设置",
  mail: "站内信",
  addCompare: "添加表型对比",
  alias: "基因同义名",
  breedingType: '保种方式',
  breedingTypes: '保种方式',
  // fullName: "基因全称",
  level: "微生物等级",
  background: "品系背景",
  coatColor: "毛色",
  source: "品系来源",
  target: "编辑基因",
  njumId: "南大ID",
  impc: "IMPC",
  num: "编号",
  doc: "参考文献",
  publications: "Publications",
  fullName: "品系名称",
  keepStatus: "品系保存状态",
  editType: "编辑类型",
  materials: "鉴定资料",
  save: "保存",
  mon: "周一",
  tue: "周二",
  wed: "周三",
  thu: "周四",
  fri: "周五",
  sat: "周六",
  sun: "周日",
  gjclmc: '构建策略文件名称',
  gjcllj: '构建策略文件链接',
  jdzlmc: '鉴定资料文件名称',
  jdzllj: '鉴定资料文件链接',
  applicationInfo: '申请人信息',
  applicationPerson: '申请人姓名',
  applicationPersonInput: '请输入申请人姓名',
  unit: '工作/学习单位',
  unitInput: '请输入工作/请输入工作/学习单位',
  captchaCode: '图形验证码',
  VerificationCode: '验证码',
  gender: '性别',
  male1: '男',
  female1: '女',
  birth: '出生年月',
  birthInput: '请选择出生年月',
  labName: '实验室名称',
  labNameInput: '请输入实验室名称',
  confirmPwd: '确认密码',
  phoneRegister: '手机号注册',
  emailRegister: '邮箱注册',
  accountInfo: '账号信息',
  PI: '实验室PI',
  PIInput: '请输入实验室PI',
  researchField: '研究领域',
  researchFieldInput: '请输入研究领域',
  unitInfo: '单位信息',
  unitName: '单位名称',
  unitInfoInput: '请输入单位名称',
  identification: '纳税人识别号',
  identificationInput: '请输入纳税人识别号',
  unitAdd: '单位地址',
  unitAddInput: '请输入单位地址',
  submit: '提交',
  register: '注册',
  sendCode: '验证码已发送，请注意查收',
  gotoLogin: '注册成功，请登录',
  login: '登录',
  userCenter: '个人中心',
  cart: '购物车',
  donation: '实物汇交',
  changePwd: '修改密码',
  resourceHome: '资源目录',
  resourceSearch: '资源检索',
  theme: '主题资源',
  themeDetail: '资源详情',
  news: '新闻公告',
  techService: '技术服务',
  standard: '标准规范',
  dataRemit: '数据汇交',
  help: '用户帮助',
  about: '关于我们',
  title: '国家遗传工程小鼠资源库',
  tips: '请输入您的手机号/邮箱',
  userNameRequire: '用户名不能为空',
  passwordRequire: '密码不能为空',
  links: '友情连接',
  quickNav: '快速导航',
  copyright: '版权所有',
  contactUs: '联系我们',
  Address: '地址：',
  Tel: '电话：',
  Email: '邮箱：',
  PageViews: '访问量：',
  codeRequire: '验证码不能为空',
  MouseRetrieval: '小鼠检索',
  ArticleRetrieval: '文章检索',
  Pinned: '置顶',
  techType: '品系技术类型',
  searchRes: '搜索结果',
  result: '搜索 ',
  countRes: '共搜索到 {count} 个结果',
  InventoryStatus: '保种方式',
  SalesStatus: '销售状态',
  StrainDescription: '品系说明',
  IP: 'IP(自主预售)',
  IF: 'IF(正常销售)',
  RD: 'RD(研发中)',
  IS: 'IS(自主品系)',
  unknown: '未知或保密',
  StrainNumber: '品系编号',
  gene: '基因',
  laws: '法律规范',
  quality: '质量标准',
  data: '数据',
  upload: '上传',
  Strains: '品系',
  Remit: '汇交',
  SubmitData: '我要上传',
  StrainRemittance: '我要汇交',
  yearRepo: '资源库年报',
  qualificationDisclosure: '相关资质',
  industryUpdates: '行业近况',
  qualityInspection: '质量检测',
  welcome2: '欢迎使用',
  articleRes: '文章搜索结果',
  views: '阅读量',
  articleDetail: '文章详情',
  articleSource: '文章来源',
  date: '时间',
  orderDetail: '订单详情',
  count: '数量',
  unit: '工作单位',
  person: '联系人',
  Handle: '操作',
  Shortlist: '我的意向',
  PendingOrder: '待下单',
  OrderPlaced: '已下单',
  AddtoShortlist: '添加意向',
  shortlistLoginRequired: '请先登录！',
  shortlistAddFailed: '添加失败，请重试',
  contactConsult: '联系咨询',
  infoOnly: '信息汇交',
  infoOnlyDescription: '该品系仅汇交信息，实体未保存在本资源库。',
  phenotypeConfidentialTag: '表型信息保密期',
  phenotypeConfidentialDescription: '该品系已具备表型信息，当前处于保密期，暂不开放查看具体内容。',
  Any: '任意',
  female: '雌',
  male: '雄',
  Pair: '对（一雌一雄）',
  Sperm: '精子',
  WeeksOld: '周龄',
  AddtoCart: '加入购物车',
  AddtoCart2: '添加购物车',
  SuccessfullyAdded: '添加成功',
  DonationInfo: '品系捐献信息',
  ApplicationType: '申请类型',
  FilterStatus: '筛选状态',
  AllStatuses: '全部状态',
  Draft: '草稿',
  PendingReview: '待审核',
  Pending: '待处理',
  Rejected: '已拒绝',
  AllTypes: '全部类型',
  ApplicationDate: '申请日期',
  CurrentStatus: '当前状态',
  detail: '详情',
  withdraw: '撤回',
  comfirmWithdraw: '此操作将撤回此数据, 是否继续?',
  Notification: '提示',
  SubmissionForm: '数据汇交信息表',
  donationForm: '实物汇交信息表',
  back: '返回',
  seeNow: '立即查看',
  reviewRecord: '你可以在“个人账号-实物汇交”中查看提交记录',
  empty: '暂无数据',
  index: '序号',
  edit: '修改',
  dataUpload: '数据上传',
  did: '已处理',
  del: '删除',
  editShortList: '修改意向',
  orderTime: '下单时间',
  serviceCase: '服务案例',
  serviceCaseDetail: '服务案例详情',
  mouseAssembly: '小鼠集结号',
  mouseAssemblyContent: '小鼠集结号内容待补充...',
  onlineQualification: '网上资质认证',
  resourceSearch: '资源搜索',
  clear: '清空',
  selected: '已选条件',
  Phenotype: '表型',
  onlyShowPhenotypeStrains: '仅显示有表型数据的品系',
  noPhenotypeResultTitle: '当前筛选条件下未检索到有表型数据的品系',
  noPhenotypeResultDesc: '建议关闭“仅显示有表型数据的品系”开关，或调整关键词和筛选条件后重试。',
  noSearchResultTitle: '当前筛选条件下暂无数据',
  noSearchResultDesc: '建议调整关键词或筛选条件后重试。',
  resourceSimpleInfo: '资源库简介',
  newsDetail: '新闻详情',
  fullName2: '基因官方名',
  alias2: '基因别称',
  chromosomeNumber: '染色体号',
  SubmissionTitle: '什么是数据汇交？',
  RemitTitle: '什么是实物汇交？',
  StrainRemittance: '实物汇交',
  currentPwd: '当前密码',
  newPwd: '新密码',
  inputPwd: '请输入您当前密码',
  setNewPwd: '请设置新密码',
  pwdLimit: '密码长度至少8位',
  enterFirst: '请输入后再选择数据',
  gotoLogin2: '密码修改成功，请重新登录',
  confirmNewPassword: "请确认新密码",
  inputEmailOrPhone: "请输入您的手机号/邮箱",
  account: '账号',
  newsTitle: '新闻公告',
  standardTitle: '标准规范',
  findPWD: '找回密码',
  inputKey: '输入品系、基因、文章标题或关键词...',
  detailAddress: '江苏省南京市浦口区江北新区学府路12号',
  detailCopyright: '南京大学 - 国家遗传工程小鼠资源库 苏ICP备1008945-1号 南信备1173号',
  JCYK: '集萃药康',
  download: '下载',
  GeneName: '基因名称',
  strainSearch: '品系编号 或 品系名 或 Njunum',
  Expand: '展开',
  Collapse: '收起',
  newsTitle: '新闻公告',
  homeHero: {
    platform: '国家级科技资源共享服务平台',
    integration: '资源整合',
    sharing: '开放共享',
    innovation: '赋能创新',
    description: '旨在针对国家生物医药创新和发展的需求，提供创新模型研发、资源收集与保藏、资源挖掘与应用、资源开放共享与服务、共性技术研发、国家科技计划形成的小鼠资源管理等服务，促进国际交流与合作。',
    proteinGenes: '靶向小鼠基因组蛋白编码基因',
    editedStrains: '基因编辑小鼠品系',
    conditionalStrains: '条件性基因敲除小鼠品系',
  },
  geneResearch: {
    strainDescription: '品系说明',
    basicTitle: '品系基础资料',
    basicSubtitle: '遗传背景与资源保存信息',
    background: '遗传背景',
    documents: '品系资料',
    strategyDocument: '构建策略',
    genotypingDocument: '鉴定资料',
    noDocuments: '暂无公开附件。',
    noFileLink: '暂无链接',
    consultStrain: '咨询该品系',
    viewDocuments: '查看品系资料',
    phenotypeOverview: '表型概览',
    informationTab: '基本信息',
    strategyTab: '构建策略',
    phenotypeTab: '实测表型',
    geneCount: '{count} 个关联基因 · 分别展示',
    hintsSubtitle: '基因层面的研究参考',
    geneTitle: '基因信息与功能',
    mouseGene: '小鼠基因',
    function: '基因功能',
    functionOriginal: '功能参考原文',
    noGenes: '当前品系暂无基因资料。',
    noFunction: '暂无可用功能资料。',
    loading: '资料加载中…',
    loadFailed: '资料暂时无法加载。',
    detailFailed: '品系详情暂时无法加载。',
    retry: '重试',
    retryFunctions: '重新加载功能资料',
    notice: '以下内容为基因层面的功能资料与研究线索，不代表本品系已验证的表型、用途或药物反应。人类同源关联不等于小鼠直接证据。',
    researchField: '研究领域',
    researchDirection: '研究方向',
    directions: '基因功能推导的研究方向',
    directionsNotice: '与品系原有研究领域分开呈现，不代表已验证用途。',
    hints: '研究线索',
    diseases: '疾病关联',
    chemicals: '药物／化合物关联',
    direct: '小鼠直接关联',
    human: '人类同源关联',
    directScope: '当前 OT 资料库仅收录人类靶点关系，不提供小鼠直接关联。',
    drugScope: 'OT 药物—靶点关系含家族和复合物映射，不等于单蛋白直接结合；不涵盖全部化学物质，也不代表本品系的药物反应。',
    search: '搜索名称或对象编号',
    filterGene: '筛选关联基因',
    allGenes: '全部基因',
    sort: '排序方式',
    nameSort: '按名称排序',
    scoreSort: '按人类同源评分排序',
    score: '关联评分',
    noScore: '暂无评分',
    scoreNotice: '评分来自 Open Targets 人类基因—疾病直接关联，多基因取最高可用分数；不是概率，也不代表本品系已验证。',
    loaded: '已加载 {count} 项',
    more: '继续加载',
    notPublished: '参考资料尚未发布。',
    unresolved: '当前基因身份尚未核实，暂不展示研究关联。',
    notRecorded: '当前资料库未收录相关线索。',
    noSearchResults: '未找到匹配的研究线索。',
    refine: '已达到分页上限，请通过名称或基因筛选缩小范围。',
  },
};
